module.exports = __webpack_public_path__ + "media/images/phe-logo-8b86a3df7de10153aaae920a41ddf78d.png";